// Auto generated file, do not manually modify!
// com.hotpads.rentpayment.handler.web.v1.RentCreditReportOptOutHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { RentCreditReportOptOutWebApiRequestDto } from '../..';

export const RentCreditReportOptOutHandler_optOut_Path = '/api/web/v1/rentCreditReport/optOut';

/**
 * Opt out of rent reporting
 */
export const RentCreditReportOptOutHandler_optOut = (
  postData: RentCreditReportOptOutWebApiRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, RentCreditReportOptOutWebApiRequestDto, void>(
    {
      endpoint: RentCreditReportOptOutHandler_optOut_Path,
      method: 'POST',
      contextPath: '/rent-payment',
      postData: postData,
    },
    client,
  );
};
